import { AfterViewInit, OnDestroy, Directive } from "@angular/core";
import { Subscription } from "rxjs";
import { ToolbarService } from "../../services/internal-services/toolbar.service";
import { toolbarOptions } from "../../../shared/model/toolbar-constants";
import { MapService } from "../../services/internal-services/map.service";

@Directive()
export abstract class BrightnessContrastComponent implements AfterViewInit, OnDestroy {
  subscriptions: Subscription[] = [];

  displayPanel = false;

  currentBrightness: number;

  currentContrast: number;

  brightnessEnabled = false;

  toolbarOption = toolbarOptions.BRIGHTNESS_CONTRAST_TOOL;

  readonly DEFAULT_VALUE = 0;

  readonly MIN_VALUE = -100;

  readonly MAX_VALUE = 100;

  readonly STEP_VALUE = 5;

  readonly CONVERSION_FACTOR = 100;

  protected constructor(
    protected mapService: MapService,
    private toolbarService: ToolbarService,
  ) {
    this.displayPanel = false;
    this.currentBrightness = this.DEFAULT_VALUE;
    this.currentContrast = this.DEFAULT_VALUE;
  }

  ngAfterViewInit() {
    this.subscriptions.push(
      this.toolbarService.enabledTool$.subscribe((enabledTool) => {
        this.displayPanel = this.toolbarOption === enabledTool;
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  togglePanelDisplay(): void {
    this.toolbarService.enableTool(!this.displayPanel ? this.toolbarOption : toolbarOptions.NONE);
  }

  reset(): void {
    this.currentBrightness = this.DEFAULT_VALUE;
    this.currentContrast = this.DEFAULT_VALUE;
    this.updateBrightness();
    this.updateContrast();
  }

  /// ///////////////////////
  /// //// BRIGHTNESS ///////
  /// ///////////////////////

  changeBrightness(event: any): void {
    this.currentBrightness = event.value;
    this.updateBrightness();
  }

  increaseBrightness(): void {
    this.currentBrightness =
      this.currentBrightness + this.STEP_VALUE <= this.MAX_VALUE
        ? this.currentBrightness + this.STEP_VALUE
        : this.currentBrightness;
    this.updateBrightness();
  }

  decreaseBrightness(): void {
    this.currentBrightness =
      this.currentBrightness - this.STEP_VALUE >= this.MIN_VALUE
        ? this.currentBrightness - this.STEP_VALUE
        : this.currentBrightness;
    this.updateBrightness();
  }

  updateBrightness(): void {
    this.mapService.getCoreMap().setBrightness(this.currentBrightness + this.CONVERSION_FACTOR);
  }

  /// /////////////////////
  /// //// CONTRAST ///////
  /// /////////////////////

  changeContrast(event: any): void {
    this.currentContrast = event.value;
    this.updateContrast();
  }

  increaseContrast(): void {
    this.currentContrast =
      this.currentContrast + this.STEP_VALUE <= this.MAX_VALUE
        ? this.currentContrast + this.STEP_VALUE
        : this.currentContrast;
    this.updateContrast();
  }

  decreaseContrast(): void {
    this.currentContrast =
      this.currentContrast - this.STEP_VALUE >= this.MIN_VALUE
        ? this.currentContrast - this.STEP_VALUE
        : this.currentContrast;
    this.updateContrast();
  }

  updateContrast(): void {
    this.mapService.getCoreMap().setContrast(this.currentContrast + this.CONVERSION_FACTOR);
  }
}
